/**
 * Bascule de son, discrete et presente sur tous les ecrans. L'etat est persiste
 * dans uiStore (localStorage), donc il survit a un rechargement.
 */
import type { ReactElement } from 'react';
import { useT } from '../locales/useT.js';
import { useUiStore } from '../store/uiStore.js';

export function MuteButton(): ReactElement {
  const t = useT();
  const muted = useUiStore((state) => state.muted);
  const toggle = useUiStore((state) => state.toggleMuted);

  return (
    <button
      type="button"
      className="mute-button"
      aria-pressed={muted}
      aria-label={muted ? t('audio.unmute') : t('audio.mute')}
      title={muted ? t('audio.unmute') : t('audio.mute')}
      onClick={toggle}
    >
      <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
        <path d="M4 9h4l5-4v14l-5-4H4z" fill="currentColor" />
        {muted ? (
          <path d="M16 9l5 6M21 9l-5 6" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" />
        ) : (
          <path
            d="M16.5 8.5a5 5 0 0 1 0 7M19 6a8.5 8.5 0 0 1 0 12"
            stroke="currentColor"
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
          />
        )}
      </svg>
    </button>
  );
}
